import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  ReferenceField,
  UrlField,
} from 'react-admin';

export const VacancyShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="description" />
      <UrlField source="externalUrl" />
      <TextField source="experience" />
      <TextField source="employment" />
      <TextField source="schedule" />
      <TextField source="salary" />
      <ReferenceField source="categoryId" reference="vacancy-categories">
        <TextField source="name" />
      </ReferenceField>
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
);
